<template>
  <div style="height:100%">
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </div>
</template>

<script>

export default {
  name: 'DowntimeLogIndex',
  components: {},
  data() {
    return {
    };
  },
  computed: {
  },
  created() {},
  methods: {
  },
  watch: {
  },
};
</script>
